const getters = {
	origin: () => process.env.VUE_APP_SPACEIN_API_CHAT_URL,
	pathPrefix: () => '/chat-api'
}

const actions = {
	request({dispatch, getters}, data) {
		return dispatch('api/requests/sendAxiosRequest', {
			...data,
			url: getters.origin+getters.pathPrefix+data.url,
		}, {root: true});
	},

	getMessageHistory({ dispatch, rootGetters }, data) {
		if(!rootGetters.getCurrentChatId) return {};
		return dispatch('request', {
			url: `/chat/history`,
			method: 'post',
			data: {
				...data,
				channelId: rootGetters.getCurrentChatId,
				limit: 20
			}
		})
	},
	postMessage({ dispatch }, data) {
		return dispatch('request', {
			url: `/chat/create`,
			method: 'post',
			data
		})
	},
	deleteMessage({ dispatch }, id) {
		return dispatch('request', {
			url: `/chat/delete/${id}`,
			method: 'delete',
		})
	},
	adminClearAllMessages({ dispatch }, id) {
		return dispatch('request', {
			url: `/chat/deletechannel/${id}`,
			method: 'delete',
		})
	},
	toggleMessageReactions({dispatch}, data) {
		return dispatch('request', {
			url: `/chat/togglereaction`,
			method: 'post',
			data
		})
	},
}

export default {
	namespaced: true,
	actions,
	getters
};
